export const MIN_MAP_ZOOM = 5;
export const MAX_MAP_ZOOM = 20;

// the zoom we expect people will actually use:
export const REFERENCE_MIN_ZOOM = 8;
export const REFERENCE_MAX_ZOOM = 17;

export const MIN_MAP_MARKER_SIZE = 2;
export const MAX_MAP_MARKER_SIZE = 10;

export const MAP_MARKER_TEXT_SIZE = 12;

// WGS-84 semi-major axis (equatorial radius)
// See https://en.wikipedia.org/wiki/World_Geodetic_System#WGS_84
const DEFAULT_RADIUS_M = 6_378_137;

// Web‐Mercator world circumference in kilometres (equator)
// See https://en.wikipedia.org/wiki/Web_Mercator_projection
export const EARTH_CIRCUMFERENCE_KM = (2 * Math.PI * DEFAULT_RADIUS_M) / 1000;

const GEOCOORD_PRECISION = 5; // About 1.1m precision
export const LATITUDE_PRECISION = GEOCOORD_PRECISION;
export const LONGITUDE_PRECISION = GEOCOORD_PRECISION;
export const ZOOM_PRECISION = 3;

// Default vector tile size (pixels).
// CARTO vector basemaps use 512 px tiles. When switching to a provider that
// serves 256 px or another size, update this constant accordingly.
export const VECTOR_TILE_SIZE = 512;

// Maplibre style URL
export const MAP_STYLE = 'https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json';

// Z-Index constants (from bottom to top)
export const ZINDEX_MAP_ATTRIBUTION = 1; // Map attribution text
export const ZINDEX_MAP_POWERED_BY = 1; // Powered by component

export const ZINDEX_MAP_MENU_BUTTON = 2; // Map menu button

export const ZINDEX_MAP_LOADING_OVERLAY = 3; // Map loading spinner overlay
export const ZINDEX_MAP_LEGEND = 3; // Map marker legend

export const ZINDEX_SIDE_PANEL = 4; // Side panel

export const ZINDEX_MAP_CARD = 5; // Floating map card/search

export const ZINDEX_BUILD_INFO = 1000; // Development build info
